import { useNavigate } from "react-router-dom";
import { useAnalytics } from "../../lib/analytics";
import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./SettingsCard.module.css";

interface SettingsCardProps {
	label: string;
	to: string;
}

export function SettingsCard({ label, to }: SettingsCardProps) {
	const navigate = useNavigate();
	const { direction } = useClientTranslations("profile");
	const { logEvent } = useAnalytics();

	const handleClick = () => {
		logEvent("settings_card_clicked", undefined, { section: to });
		navigate(to);
	};

	return (
		<button
			type="button"
			className={styles.card}
			onClick={handleClick}
			dir={direction}
		>
			<span className={styles.label}>{label}</span>
			<svg
				className={styles.chevron}
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Navigate</title>
				<path
					d="M6 4L10 8L6 12"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	);
}
